import { Navigate } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";


interface ProtectedRouteProps {
    component: React.ComponentType;
}


const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component }) => {
    const { isAuthenticated } = useAuth();

    return isAuthenticated ? (
        
        <Component />
    ) : (
        <Navigate to="/login" />
    )
}

export default ProtectedRoute;